import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";

import {
  Row,
  Col,
  Container,
} from "reactstrap";
import {
  SearchableSelectHookForm,
} from "../../../layout/HookFormInputs";
import {
  userDetails,
} from "../../../../helper";
import { useDispatch, useSelector } from "react-redux";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import Switch from "react-switch";
// import AddEditRequest from "./AddSupplier";
import { EMPTY_DATA, defaultPageSize } from "../../../../config/constants";
import NoContentFound from "../../../common/NoContentFound";

import LoaderCustom from "../../../common/LoaderCustom";
import Toaster from "../../../common/Toaster";
import { Drawer } from "@material-ui/core";
// import { ApplyPermissionForLegalDocument } from ".";
import {
  AddAuditDocumentApproverMaster,
  deleteDocumentApproverMaster,
  getApproverListService,
  getProfileCodeService,
} from "../Action";

const Document = ({ props }) => {
  const { loading } = useSelector(
    (state) => state?.LegalDocumentReducer
  );
  const dispatch = useDispatch();

  const [submitLoading, setSubmitionLoading] = useState(false);

  const [noData, setNoData] = useState(false);
  const [loader, setloader] = useState(false);
  const [globalTake, setGlobalTake] = useState(defaultPageSize);
  const [gridApi, setgridApi] = useState(null); // DONT DELETE THIS STATE , IT IS USED BY AG GRID
  const [categoriesDropDown, setcategoriesDropDown] = useState([]);
  const [profileCodeData, setprofileCodeData] = useState([]);


  const [open, setOpen] = useState(false);
  const {
    handleSubmit,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm();

  const handleCloseDrawer = () => {
    setOpen(false); // Close the drawer
  };

  const renderListing = (label) => {
    if (label === "ProfileCodeData") {
      return categoriesDropDown.map((category) => ({
        value: category.Id,
        label: category.Name,
      }));
    }
  };

  //----listing and adding functions
  const getProfileCodeServiceListData = () => {
    setSubmitionLoading(true); // Set loading to true when fetching data starts for profile code service
    getProfileCodeService()
      .then((res) => {
        setprofileCodeData(res?.result?.data);
        setSubmitionLoading(false); // Set loading to false after data is fetched for profile code service
      })
      .catch(() => {
        setSubmitionLoading(false); // Set loading to false if an error occurs during data fetching for profile code service
      });
  };
  const getProfileCodeService1 = () => {
    getApproverListService()
      .then((res) => {
        setcategoriesDropDown(res?.Data?.profileCodes);
      })
      .catch(() => { });
  };
  useEffect(() => {
    getProfileCodeService1();
    getProfileCodeServiceListData();
  }, []);

  const gridOptions = {};

  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,

    // headerCheckboxSelection: (isSimulation || props?.benchMark) ? isFirstColumn : false,
    headerCheckboxSelectionFilteredOnly: true,
    // checkboxSelection: isFirstColumn
  };

  const onGridReady = (params) => {
    setgridApi(params.api);
    params.api.sizeColumnsToFit();
    // setgridColumnApi(params.columnApi);
    params.api.paginationGoToPage(0);
    const checkBoxInstance = document.querySelectorAll(
      ".ag-input-field-input.ag-checkbox-input"
    );
    checkBoxInstance.forEach((checkBox, index) => {
      const specificId = `RM_Domestic_Checkbox${index / 11}`;
      checkBox.id = specificId;
    });
    const floatingFilterInstances = document.querySelectorAll(
      ".ag-input-field-input.ag-text-field-input"
    );
    floatingFilterInstances.forEach((floatingFilter, index) => {
      const specificId = `RM_Domestic_Floating${index}`;
      floatingFilter.id = specificId;
    });
  };

  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const handleDeletePopup = () => {
      // Set loader to true to indicate delete operation is in progress
      setSubmitionLoading(true);

      deleteDocumentApproverMaster(props?.data.id, (error, response) => {
        // Set loader to false once the delete request is complete
        setSubmitionLoading(false);

        if (error) {

          Toaster.error(error?.response?.data?.ErrorMessage);
          // Handle the error as needed
        } else {
          Toaster.success(response?.data?.Data?.Message);
          // Fetch updated data after deletion
          getProfileCodeServiceListData();
        }
      });
    };

    return (
      <div>


        <button
          title="Delete"
          className="Delete hl-delete-icon"
          type="button"
          onClick={handleDeletePopup}
        ></button>
      </div>
    );
  };

  const onSubmit = async (data) => {
    let empId = userDetails();
    let ProfileCodesData = data?.ProfileCodes?.map((item) => item.value); // Extracting values from each item in the array
    setSubmitionLoading(true); // Set loading indicator to true
    try {
      const scoreRanges = {
        ProfileCodes: ProfileCodesData,
        EmployeeId: empId?.EmployeeId,
      };
      const res = await new Promise((resolve) => {
        dispatch(AddAuditDocumentApproverMaster(scoreRanges, resolve));
      });

      if (res && res.IsSuccessful) {
        // Handle successful response
        // getAuditMasterList();
        Toaster.success(res?.Data?.Message);
        setOpen(false);
        getProfileCodeServiceListData();
        setValue("ProfileCodes", "")
        // Further actions...
      } else {
        // Handle unsuccessful response

      }
      // Check ascending order and maximum range

    } catch (error) {
      // Handle errors

    } finally {
      setSubmitionLoading(false); // Set loading indicator to false after completion or error
    }
  };

  const downloadButtonFormatter = (params) => {
    const handleDownload = (file) => {
      if (file) {
        // Create a hidden anchor element to trigger the download
        const link = document.createElement("a");

        if (typeof file === "string") {
          // If it's a string and starts with 'http', assume it's a URL
          link.href = file;
          
        } else {
          // Handle other cases or throw an error

          return;
        }

        link.target = "_blank";
        link.download = "downloadedFile";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };

    const documentUrl = params.data?.documentUrl;

    return (
      <>
        <button
          title="Download"
          className="hl-upload-btn btn btn-secondary mt-1"
          type="button"
          onClick={() => {
            handleDownload(documentUrl);
          }}
        >
          <div className="download mr-0"></div>
        </button>
      </>
    );
  };

  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject, rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
        </label>
      </>
    );
  };
  /**
   * @method effectiveDateFormatter
   * @description Renders buttons
   */

  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    downloadButtonFormatter: downloadButtonFormatter,
    // hyphenFormatter: hyphenFormatter,
    customNoRowsOverlay: NoContentFound,
    // checkBoxRenderer: checkBoxRenderer,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };
  /**
   * @method statusButtonFormatter
   * @description Renders buttons
   */

  // const handleDeleteLegalDocument = (documentId) => {
  //   setDeleteLoader(true); // Set deleteLoader to true to indicate delete operation is in progress

  const cancel = () => {
    setOpen(false);
    // resetForm();
  };
  return (
    <>
      {submitLoading ? (
        <LoaderCustom customClass={"loader-center"} />
      ) : (
        <div className="bg-white hl-common-page pt-4">
          <Row className="ag-grid-react without-filter-grid">
            <Col>
              <div
                className={`ag-grid-wrapper custom-pagination overlay-contain ${props?.isDataInMaster && !noData
                  ? "master-approval-overlay"
                  : ""
                  } ${noData
                    ? "overlay-contain"
                    : ""
                  }`}
              >
                <div
                  className={`ag-theme-material ${loading && "max-loader-height"
                    }`}
                >
                  {noData && (
                    <NoContentFound
                      title={EMPTY_DATA}
                      customClassName="no-content-found"
                    />
                  )}
                  <Row className="filter-row-large text-start mb-0">
                    {/* <Col md="3" className="mb-0">
                    <input
                      type="text"
                      className="form-control table-search"
                      placeholder="Search"
                      autoComplete={"off"}
                    // onChange={handleChange}
                    />
                  </Col> */}
                    <Col md="12" className="mb-3 d-flex justify-content-end">
                      <button
                        className="user-btn"
                        title="Add New Specialization"
                        onClick={() => {
                          setOpen(true);
                        }}
                      >
                        <div className={"plus mr-0"}></div>
                      </button>
                    </Col>
                  </Row>
                  <AgGridReact
                    style={{ height: "100%", width: "100%" }}
                    defaultColDef={defaultColDef}
                    floatingFilter={true}
                    domLayout="autoHeight"
                    rowData={profileCodeData || []}
                    // onFilterChanged={onFilterChanged}
                    pagination={false}
                    paginationPageSize={globalTake}
                    onGridReady={onGridReady}
                    gridOptions={gridOptions}
                    noRowsOverlayComponent={"customNoRowsOverlay"}
                    noRowsOverlayComponentParams={{
                      title: EMPTY_DATA,
                      imagClass: "imagClass",
                    }}
                    frameworkComponents={frameworkComponents}
                    rowSelection={"multiple"}
                    suppressRowClickSelection={true}
                    enableBrowserTooltips={true}
                  >
                    <AgGridColumn
                      // cellClass="has-checkbox"
                      headerName="S. No."
                      field="serialNumber"
                      floatingFilter={false}
                      valueGetter={(params) => params.node.rowIndex + 1}
                      sortable={false}
                    ></AgGridColumn>

                    <AgGridColumn
                      cellClass="has-checkbox"
                      field="profileName"
                      floatingFilter={false}
                      headerName="Profile Name"

                    // cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>
                    <AgGridColumn
                      cellClass="has-checkbox"
                      field="employeeName"
                      floatingFilter={false}
                      headerName="Created By"

                    // cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>

                    <AgGridColumn
                      headerName="Action"
                      sortable={false}
                      cellRenderer={"totalValueRenderer"}
                      type="rightAligned"
                      floatingFilter={false}
                    // tooltipComponent={'customTooltip'}
                    ></AgGridColumn>
                  </AgGridReact>
                  {/* Add a new AgGridColumn for buttons */}
                </div>
              </div>
            </Col>
          </Row>
          <Drawer
            open={open}
            anchor="right" // Assuming you want the drawer to open from the right side
            onClose={handleCloseDrawer} // Close the drawer when clicking outside or pressing ESC key
          >
            <Container>
              {loader && <LoaderCustom />}
              <div className={"drawer-wrapper"}>
                <Row className="drawer-heading">
                  <Col md="12">
                    <div className={"header-wrapper left"}>
                      <h3>{"Add Exception Approval"}</h3>
                    </div>
                    <div
                      onClick={cancel}
                      className={"close-button right"}
                    ></div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Row className="part-detail-wrapper hl-filter-inputs pl-3">
                        <Col md="12">
                          <label className="pb-2">The given exception flow is applicable for Factory License, ISO, PSA & Payment Terms</label>
                          <SearchableSelectHookForm
                            label={"Profile Code"}
                            name={"ProfileCodes"}
                            placeholder={"Select"}
                            Controller={Controller}
                            control={control}
                            rules={{ required: true }}
                            handleChange={() => ({})}
                            register={register}
                            options={renderListing("ProfileCodeData")}
                            mandatory={true}
                            errors={errors.ProfileCodes}
                            disabled={false}
                            isMulti={true}
                          />
                        </Col>
                        <Col
                          md="12"
                          className="mt-3 justify-content-between d-flex"
                        >
                          <div className="col-sm-12 text-right">
                            <button
                              type={"button"}
                              className="reset mr15 cancel-btn"
                              onClick={cancel}
                            >
                              <div className={"cancel-icon"}></div>
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="submit-button save-btn"
                            >
                              <div className="save-icon"></div> Save
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </Col>
                </Row>
              </div>
            </Container>
          </Drawer>
        </div>
      )}
    </>
  );
};

export default Document;
